import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { authApi } from '@/utilities/axios';
import { useAuthStore } from '@/modules/auth/store';
import { showToast } from '@/utilities/toast-handler';
import { useRoute } from 'vue-router';

const FILE_UPLOAD_URL = process.env.VUE_APP_API_VERSION + '/upload';
const FILE_DOWNLOAD_URL = process.env.VUE_APP_API_VERSION + '/download';
const FILE_DELETE_URL = process.env.VUE_APP_API_VERSION + '/remove';

export const usefileStore = defineStore('fileUpload', () => {
    const authStore = useAuthStore();
    const company_id = computed(() => {
        return authStore.getLoggedUserCompanyId;
    });

    //states
    const files = ref([]);
    const fileData = ref([]);
    const uploading = ref(false);
    const route = useRoute();
    //actions
    const uploadFiles = async () => {
        try {
            uploading.value = true;

            //Cleaning files from the last upload
            fileData.value = [];

            for (let i = 0; i < files.value.length; i++) {
                const formData = new FormData();
                formData.append('file', files.value[i]);
                const response = await authApi.post(`${FILE_UPLOAD_URL}?company_id=${company_id.value}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.statusCode == 201) {
                    fileData.value.push(response.data);
                }
            }

            uploading.value = false;

            return fileData.value;
        } catch (error) {
            uploading.value = false;
            let errorMsg = error?.data?.message ?? 'Failed to upload Files';
            if (errorMsg === 'No file was uploaded') {
                errorMsg = 'File is too large. Maximum allowed size is 4 MB.';
            }
            showToast({}, errorMsg);
        }
    };

    const downloadFile = async (fileId, fileName) => {
        try {
            const response = await authApi.get(`${FILE_DOWNLOAD_URL}/${fileId}?company_id=${company_id.value}`, { responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a link element and set its attributes
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);

            // Append the link to the document body and trigger a click event
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to download Files');
        }
    };


    const removeFile = async (fileId, task) => {
        try {
            const taskId = parseInt(route.query.taskId);
            const confirmDelete = confirm('Are you sure you want to remove this file?');

            if (!confirmDelete) return;
            let res =  await authApi.post(`${FILE_DELETE_URL}/${fileId}/${taskId}?company_id=${company_id.value}`);

            if(res.statusCode == 200) {
                task.attachment = task.attachment.filter(item => item?.file?.id !== fileId);
                task.files_attached = task.files_attached.filter(id => id !== fileId);
                showToast({ severity: 'success', summary: 'Success' }, 'Attachment removed successfully');
            }

        } catch (error) {
            // showToast({}, error ?? 'Failed to remove file');
        }
    };


    return {
        //state
        files,
        fileData,
        uploading,

        //actions
        uploadFiles,
        downloadFile,
        removeFile
    };
});
